(function () {
    if (!window.bootstrap) {



        const collapsers = document.querySelectorAll('[data-bs-toggle="collapse"]');
        if (collapsers) {
            collapsers.forEach((element) => {
                const target = element.dataset.bsTarget;
                element.onclick = function (e) {
                    console.log("clicked!")
                    e.preventDefault();
                    const expanded = element.getAttribute("aria-expanded") == "true";
                    const targetElementId = target.substring(1);
                    targetElement = document.getElementById(targetElementId);
                    const collapserSet = document.querySelectorAll(`[data-bs-target="#${targetElementId}"]`);

                    if (!expanded) {
                        targetElement.classList.add("show");
                        collapserSet.forEach((cs) => {
                            cs.setAttribute("aria-expanded", "true");
                            cs.classList.remove("collapsed")
                        })
                    } else {
                        targetElement.classList.remove("show");
                        collapserSet.forEach((cs) => {
                            cs.setAttribute("aria-expanded", "false");
                            cs.classList.add("collapsed")
                        })
                    }

                }
            })
        }
    }
})();